module.exports = __webpack_public_path__ + "static/media/logo_scbbank.2ed72c1b.svg";